import type { RootState } from 'types/root-state';

import { popularCategoriesInitialState } from './slice';

const selectDomain = (state: RootState) =>
	state.spl.popularCategories || popularCategoriesInitialState;

export const selectPopularCategories = (state: RootState) => selectDomain(state).data;
export const selectIsModalOpen = (state: RootState) => selectDomain(state).isModalOpen;
export const selectModalData = (state: RootState) => selectDomain(state).modalData;
